import React, { FC } from 'react';

interface ProgressSpinnerProps {
    size?: string;
    strokeWidth?: string;
    fill?: string;
    animationDuration?: string;
}

export const ProgressSpinner: FC<ProgressSpinnerProps> = ({
    size = 'w-12 h-12',
    strokeWidth = '3',
    fill = 'none',
    animationDuration = '2s',
}) => (
    <div className={`relative mx-auto inline-block ${size}`} role="progressbar">
        <svg
            className="w-full h-full animate-spinner-spin"
            viewBox="25 25 50 50"
            style={{ animationDuration }}
        >
            <circle
                className="animate-progress-spinner-dash stroke-minsk"
                cx="50"
                cy="50"
                r="20"
                fill={fill}
                strokeWidth={strokeWidth}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeDasharray="1, 200"
                strokeDashoffset="0"
            />
        </svg>
    </div>
);
